/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Error_Microsoft_UnconfirmedInputs */



/**
* | output |
* | --- |
* | "Your Microsoft account does not confirm this email address. Use the email link instead." |
*
* @param {Portal_X13_Error_Microsoft_UnconfirmedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portal_x13_error_microsoft_unconfirmed = /** @type {((inputs?: Portal_X13_Error_Microsoft_UnconfirmedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Error_Microsoft_UnconfirmedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Your Microsoft account does not confirm this email address. Use the email link instead.")
});